
import { motion } from 'framer-motion';

const AnimateElem = ({ elem, delay = 0, finalscale = 1, animate = false }) => {
    if (animate) {
        return <motion.div
            animate={{
                scale: [1, 2, 2, 1, finalscale],
                // rotate: [0, 0, 180, 180, 0],
                borderRadius: ["0%", "0%", "50%", "50%", "0%"],
            }}
            transition={{
                delay: delay,
                duration: 2,
                ease: "easeInOut",
                times: [0, 0.2, 0.5, 0.8, 1],
            }}
        >
            {elem}
        </motion.div>;
    } else {
        return <motion.div>
            {elem}
        </motion.div>;
    }
}

export default AnimateElem;